import React, { useState, useEffect } from "react";
import "../styles/Admin.css";

function Chatrequests() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [chatlogs, setChatlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const recordsPerPage = 10;
  const totalPages = Math.ceil(chatlogs.length / recordsPerPage);

  useEffect(() => {
    fetchChatLogs();
  }, []);

  const fetchChatLogs = async () => {
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(`${API_BASE_URL}/Admin/getchatreq`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch Chat logs");

      const data = await response.json();
      setChatlogs(data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching chat logs:", error);
      setError("Error fetching chat logs.");
      setLoading(false);
    }
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = chatlogs.slice(indexOfFirstRecord, indexOfLastRecord);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div>
      <h2>📊 Chat Logs</h2>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : chatlogs.length === 0 ? (
        <p>No Chat logs found.</p>
      ) : (
        <>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Text</th>
                <th>ImageURL</th>
                <th>Createdat</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.map((log) => (
                <tr key={log.id}>
                  <td>{log.username}</td>
                  <td>{log.text}</td>
                  <td>{log.imageUrl}</td>
                  <td>{new Date(log.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* ✅ Pagination Controls */}
          <div className="pagination">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
              ◀️ Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
              Next ▶️
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default Chatrequests;
